import { Drawer } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import React, { FC } from 'react';
import styled from 'styled-components';

import { useHeaderMeasure } from 'hooks/globals';

export const AsideStyles = styled.aside`
  position: sticky;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid ${tokens.colors.gray};
  padding-top: ${tokens.space.large};

  @media (max-width: ${tokens.breakpoints.s}) {
    display: none;
  }
`;

export const DrawerBody = styled(Drawer.Body)`
  padding: ${tokens.space.large};
`;

type AsideProps = {
  className?: string;
};

export const Aside: FC<AsideProps> = ({ children, className }) => {
  const [measure] = useHeaderMeasure();

  return (
    <AsideStyles
      className={className}
      style={{
        height: `calc(100vh - ${measure?.bottom}px)`,
        top: `${measure?.bottom}px`,
      }}
    >
      {children}
    </AsideStyles>
  );
};
